// components/DuplicatePanel.tsx
import React from 'react';
import { Paper, Typography, List, ListItem, ListItemText, Button, Box } from '@mui/material';
import { colors } from '../theme';
import { NAVIGATION_CONFIG } from '../config/api';

interface DuplicatePanelProps {
  duplicateMatches: any[];
  checkingDuplicates: boolean;
  customerToken?: string | null;
  threshold: number;
  onSelectCustomer?: (customer: any) => void;
}

const MAX_MATCHING_SCORE = 100;

export const DuplicatePanel: React.FC<DuplicatePanelProps> = ({
  duplicateMatches,
  checkingDuplicates,
  customerToken,
  threshold,
  onSelectCustomer,
}) => {
  return (
    <Paper
      sx={{
        p: 2,
        mb: 3,
        border: `2px solid ${colors.alert.border}`,
        background: colors.background.warning,
      }}
    >
      <Typography variant="h6" color="warning.main" sx={{ mb: 1 }}>
        {checkingDuplicates
          ? "Checking for possible duplicates..."
          : "Possible duplicate customers found:"}
      </Typography>
      {checkingDuplicates ? (
        <Typography variant="body2">Checking...</Typography>
      ) : (
        <List dense>
          {duplicateMatches.map((match, idx) => {
            const dob = match.dateOfBirth
              ? match.dateOfBirth.split("T")[0]
              : "";
            return (
              <ListItem
                key={idx}
                divider={idx < duplicateMatches.length - 1}
                sx={{
                  backgroundColor:
                    match.score === MAX_MATCHING_SCORE
                      ? colors.alert.backgroundHigh
                      : match.score >= threshold
                      ? colors.alert.backgroundMedium
                      : "inherit",
                }}
              >
                <ListItemText
                  primary={
                    <span>
                      <b>
                        {match.firstName} {match.lastName}
                      </b>{" "}
                      (Score: {match.score}%)
                    </span>
                  }
                  secondary={
                    <>
                      <span>
                        DOB: {dob} | Email: {match.email || "-"} |
                        Phone: {match.primaryPhone || "-"} | Postcode:{" "}
                        {match.primaryPostcode || "-"}
                      </span>
                      <br />
                      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                        <Button
                          size="small"
                          onClick={() => {
                            const customerUrl = `${window.location.origin}${NAVIGATION_CONFIG.getCustomerDetailRoute(match.customerExternalId)}`;
                            window.open(
                              customerUrl,
                              "_blank",
                              "noopener,noreferrer"
                            );
                          }}
                        >
                          View Customer
                        </Button>
                        {customerToken && onSelectCustomer && (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => onSelectCustomer(match)}
                          >
                            Select Customer
                          </Button>
                        )}
                      </Box>
                    </>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </Paper>
  );
};